import { Component, OnInit, ViewChild } from '@angular/core';
import { WindowService } from '../service/window.service';
import firebase from 'firebase';
import { environment } from '../../environments/environment';
import { Router, NavigationExtras } from '@angular/router';
import { ElectService } from '../service/elect.service';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import { CountdownComponent, CountdownConfig, CountdownEvent } from 'ngx-countdown';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-voterreg',
  templateUrl: './voterreg.component.html',
  styleUrls: ['./voterreg.component.css']
})
export class VoterregComponent implements OnInit {
  @ViewChild('countdown') counter: CountdownComponent;
  config: CountdownConfig = { leftTime: 20, format: 'mm:ss' };
  windowRef: any;
  phoneNumber: any;
  verificationCode: string;
  user: any;
  name: string = '';
  addForm: FormGroup;
  otpForm: FormGroup;
  isLogin: boolean = false;
  btnEnable = true;
  resentOtp: boolean = false;
  
  mobno;
  uid;

  auth;

  enableRegister;
	constructor(
		private ats: AngularFireAuth,
		private win: WindowService, 
		public router: Router, 
		private elsrv: ElectService, 
		public frmBldr: FormBuilder, ) { 
	//	firebase.initializeApp(environment.firebaseConfig);

	}

 hideloader() { 
  
            // Setting display of spinner 
            // element to none 
            document.getElementById('loading') 
                .style.display = 'none'; 
} 

 ngOnInit() {
   this.windowRef = this.win.windowRef;
   this.ats.authState.subscribe(data => {
      if (data){
        this.isLogin = true;
        this.mobno = data.phoneNumber;
        this.uid = data.uid;
        this.elsrv.getVoter(data.phoneNumber).subscribe(dta =>{
              if(dta.length == 1){
                this.router.navigate(['/compartment'], { queryParams: { key: data.phoneNumber, uid: data.uid }, skipLocationChange: false });
              }
        });
      } else {
        this.isLogin = false;
        this.btnEnable = true;
        this.resentOtp = false;

        this.windowRef.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-o', {
          size: 'invisible'
        })
        this.windowRef.recaptchaVerifier.render();
      }     
   });

		this.ats.onAuthStateChanged(da => {
			if(da == null){
				this.isLogin = false;
        this.btnEnable = true;
        this.resentOtp = false;
			}else{
				this.mobno = da.phoneNumber;
				this.uid = da.uid;
        this.isLogin = true;
			}
		});

	    this.otpForm = this.frmBldr.group({
	    	phoneNumber:[null, Validators.required]
	    });

	    this.addForm = this.frmBldr.group({
          phoneNumber:[null, Validators.required],
          fullName:[null, Validators.required],
          location:[null, Validators.required],
          rdblock:[null, Validators.required],
          district:[null, Validators.required],
          cscid:[null, Validators.required]
       });

     // this.checkTime();
	}

 sendLoginCode() {
    this.resentOtp = true;
    this.btnEnable = false;
  	const appVerifier = this.windowRef.recaptchaVerifier;
    const aw = this.phoneNumber;
    const num = "+91" + aw;
   	try {
  	        firebase.auth().signInWithPhoneNumber(num, appVerifier)
  		    .then(result => {
  		     this.windowRef.confirmationResult = result;
  		     this.btnEnable = false;
           this.resentOtp = true;
  		    })
  		    .catch( error => {
  		    	this.btnEnable = true;
            this.resentOtp = false;
  		    	alert(error);
  		    });
   	}
   	catch(error){
   		console.log(error)
   	}
   	finally{
  	 	this.counter.restart(); 		
   	}
  }
  verifyLoginCode() {
    this.windowRef.confirmationResult
      .confirm(this.verificationCode)
      .then( result => {
        this.user = result.user;
        this.elsrv.getVoter(result.user.phoneNumber).subscribe(data => {
          if(data.length == 1){
            this.router.navigate(['/unregvoter'], { queryParams: { stat: 'noact' }, skipLocationChange: false });
          }else{
          	this.isLogin = true;
          }
        });
    })
    .catch( error => alert("Invalid OTP"));
  }

  handleEvent($event){
	const stat = $event.action;
	if(stat == 'done'){
		this.btnEnable = true;
    this.resentOtp = false;
	}
  }

  reset(){
    this.ats.signOut();
  }
  submitData(){
    const createAt = firebase.firestore.FieldValue.serverTimestamp(); 
    const data = {
      phoneNumber : this.addForm.controls['phoneNumber'].value,
      fullName: this.addForm.controls['fullName'].value,
      location: this.addForm.controls['location'].value,
      rdblock: this.addForm.controls['rdblock'].value,
      district: this.addForm.controls['district'].value,
      cscid: this.addForm.controls['cscid'].value,
      regDate: createAt,
      isApproved: false
    }
    this.elsrv.addVoter(this.uid, data);
    this.router.navigate(['/regsuccess'], { queryParams: { stat: 'ro' }, skipLocationChange: false });
  }

  checkTime(){
    const sdate = new Date("2020/12/14 00:00:01").getTime();
    const ndate = new Date().getTime();

    if(ndate < sdate){
      this.enableRegister = true;
    }else{
      this.enableRegister = false;
    }
  }
}